// 페이지네이션 (2026-07-20) — 사용자 목록류 공용. 클라이언트 사이드(데이터는 이미
// 로드됨)라 페이지 전환 즉시. 총 건수·페이지 크기 선택·번호(최대 7개 창)·이전/다음.
import MiniSelect from "@/components/MiniSelect";

const _SIZE_OPTS = [20, 50, 100].map((n) => ({ value: n, label: `${n}개씩` }));

export default function Pagination({ total, page, onPageChange, pageSize, onPageSizeChange }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const cur = Math.min(page, pages);
  // 번호 창: 현재 페이지 중심 최대 7개
  const start = Math.max(1, Math.min(cur - 3, pages - 6));
  const nums = Array.from({ length: Math.min(7, pages) }, (_, i) => start + i);

  if (total <= 0) return null;
  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-[12.5px] text-ink-500">
      <span className="flex items-center gap-1.5">
        총 {total.toLocaleString("ko-KR")}명 ·
        <MiniSelect value={pageSize} options={_SIZE_OPTS} plain
                    onChange={(v) => { onPageSizeChange(+v); onPageChange(1); }} />
      </span>
      <span className="flex items-center gap-1">
        <button type="button" disabled={cur <= 1} onClick={() => onPageChange(cur - 1)}
                className="rounded-md px-2 py-1 hover:bg-ink-100 disabled:opacity-30">‹</button>
        {nums.map((n) => (
          <button key={n} type="button" onClick={() => onPageChange(n)}
                  className={`min-w-[28px] rounded-md px-2 py-1 tabular-nums ${
                    n === cur ? "bg-brand-600 font-semibold text-white" : "hover:bg-ink-100"}`}>
            {n}
          </button>
        ))}
        <button type="button" disabled={cur >= pages} onClick={() => onPageChange(cur + 1)}
                className="rounded-md px-2 py-1 hover:bg-ink-100 disabled:opacity-30">›</button>
      </span>
    </div>
  );
}
